import { render, staticRenderFns } from "./Tosign.vue?vue&type=template&id=9361c012"
import script from "./Tosign.vue?vue&type=script&lang=js"
export * from "./Tosign.vue?vue&type=script&lang=js"
import style0 from "./Tosign.vue?vue&type=style&index=0&id=9361c012&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports